export const COLLECTIONS = {
  RESOURCES: 'businesses/{businessId}/resources',
} as const
